import axios from 'axios';

// Replace with actual API Gateway URL after deployment
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://your-api-gateway-url.com/Prod';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('idToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export async function listPosts(params = {}) {
  const response = await api.get('/posts', { params });
  return response.data;
}

export async function getPost(postId) {
  const response = await api.get(`/posts/${postId}`);
  return response.data;
}

export async function createPost(postData) {
  const response = await api.post('/posts', postData);
  return response.data;
}

export async function updatePost(postId, postData) {
  const response = await api.put(`/posts/${postId}`, postData);
  return response.data;
}

export async function deletePost(postId) {
  const response = await api.delete(`/posts/${postId}`);
  return response.data;
}

export async function getCurrentUserProfile() {
  const response = await api.get('/users/me');
  return response.data;
}

// Ask the API for a presigned S3 PUT URL for one image on a post.
export async function getUploadUrl(postId, filename, contentType) {
  const response = await api.post(`/posts/${postId}/uploads`, { filename, contentType });
  return response.data; // { uploadUrl, key, publicUrl }
}

// Upload the file straight to S3 with the presigned URL. Uses a bare axios
// call (not the `api` instance) so no Authorization header is added — the
// presigned query params are the only auth S3 wants.
export async function uploadFileToS3(uploadUrl, file) {
  await axios.put(uploadUrl, file, {
    headers: { 'Content-Type': file.type || 'application/octet-stream' }
  });
}

// Create post, upload any images, then attach their URLs to the post.
export async function createPostWithImages(postData, files) {
  const post = await createPost(postData);
  if (!files || files.length === 0) return post;

  const urls = [];
  for (const file of files) {
    const { uploadUrl, publicUrl } = await getUploadUrl(
      post.post_id,
      file.name,
      file.type || 'application/octet-stream'
    );
    await uploadFileToS3(uploadUrl, file);
    urls.push(publicUrl);
  }
  const updated = await updatePost(post.post_id, { images: urls });
  return updated;
}
